/* ============================================================
   COFO DESK STUDIO – 商品詳細LP
   デスクSTUDIO_LP/js/main.js からの移植版。

   ・SP用メディア（data-src-sp）差し替え
   ・スクロールリベール
   ・カルーセル（DETAIL / LINE UP / GALLERY 共通）
   ・LINE UP カラータブ
   ・SPEC タブ切替
   ・イントロ動画のクリック再生
   ・ビューポート内の背景動画だけ再生

   OPENING演出 / ヘッダー色の反転 / SPドロワー / スティッキーCTA /
   Q&Aアコーディオンはテーマ側に任せるため移植していない。
   ============================================================ */
(function () {
  'use strict';

  var SP_QUERY = '(max-width: 900px)';
  var mqSp = window.matchMedia(SP_QUERY);
  var isSp = function () { return mqSp.matches; };

  function init(root) {
    if (!root || root.dataset.cdsReady === '1') return;
    root.dataset.cdsReady = '1';

    /* ----------------------------------------------------------
       SP用メディア差し替え
       img / video に data-src-sp, data-poster-sp があれば入れ替える
       ---------------------------------------------------------- */
    function swapResponsiveMedia() {
      root.querySelectorAll('[data-src-sp]').forEach(function (el) {
        if (!el.dataset.srcPc) {
          el.dataset.srcPc = el.getAttribute('src') || '';
          el.dataset.posterPc = el.getAttribute('poster') || '';
        }
        var wantSp = isSp();
        var nextSrc = wantSp ? el.dataset.srcSp : el.dataset.srcPc;
        var nextPoster = wantSp
          ? (el.dataset.posterSp || el.dataset.posterPc)
          : el.dataset.posterPc;

        if (nextSrc && el.getAttribute('src') !== nextSrc) {
          el.setAttribute('src', nextSrc);
          if (el.tagName === 'VIDEO') el.load();
        }
        if (el.tagName === 'VIDEO' && nextPoster) el.setAttribute('poster', nextPoster);
      });
    }
    swapResponsiveMedia();
    mqSp.addEventListener('change', swapResponsiveMedia);

    /* ----------------------------------------------------------
       スクロールリベール
       ---------------------------------------------------------- */
    var revealTargets = root.querySelectorAll('[data-reveal]');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
      revealTargets.forEach(function (el) { io.observe(el); });
    } else {
      revealTargets.forEach(function (el) { el.classList.add('is-in'); });
    }

    /* ----------------------------------------------------------
       カルーセル
       - data-carousel               … ルート
       - data-carousel-groups="a,b"  … グループ（LINE UPのカラー切替）
       ---------------------------------------------------------- */
    function initCarousel(carouselRoot) {
      var track = carouselRoot.querySelector('.carousel__track');
      if (!track) return null;

      var allItems = Array.prototype.slice.call(track.children);
      var groups = (carouselRoot.dataset.carouselGroups || '').split(',').filter(Boolean);
      var currentGroup = groups.length ? groups[0] : null;

      // カウンター・プログレスは「このカルーセル」と直前の .sec-head の両方を対象にする
      var scope = [carouselRoot];
      var head = carouselRoot.previousElementSibling;
      if (head && head.classList.contains('sec-head')) scope.push(head);

      function slice(nl) { return Array.prototype.slice.call(nl); }
      function els(sel) {
        var out = [];
        scope.forEach(function (s) { out = out.concat(slice(s.querySelectorAll(sel))); });
        return out;
      }

      var curEls = els('[data-carousel-current]');
      var totalEls = els('[data-carousel-total]');
      var bar = carouselRoot.querySelector('[data-carousel-bar]');

      var index = 0;

      function visibleItems() {
        if (!currentGroup) return allItems;
        return allItems.filter(function (li) { return li.dataset.group === currentGroup; });
      }

      function pad(n) { return String(n).padStart(2, '0'); }

      function render() {
        var items = visibleItems();
        var total = items.length;
        if (!total) return;
        if (index > total - 1) index = total - 1;
        if (index < 0) index = 0;

        // グループ外は非表示
        allItems.forEach(function (li) {
          li.style.display = (!currentGroup || li.dataset.group === currentGroup) ? '' : 'none';
        });

        track.style.transform = 'translate3d(' + (-index * 100) + '%,0,0)';
        curEls.forEach(function (el) { el.textContent = pad(index + 1); });
        totalEls.forEach(function (el) { el.textContent = pad(total); });
        if (bar) bar.style.width = (100 / total) * (index + 1) + '%';
      }

      function go(delta) {
        var total = visibleItems().length;
        index = (index + delta + total) % total;
        render();
      }

      var prev = carouselRoot.querySelector('[data-carousel-prev]');
      var next = carouselRoot.querySelector('[data-carousel-next]');
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });

      // スワイプ
      var sx = 0, sy = 0, swiping = false;
      var vp = carouselRoot.querySelector('.carousel__viewport');
      if (vp) {
        vp.addEventListener('touchstart', function (e) {
          sx = e.touches[0].clientX; sy = e.touches[0].clientY; swiping = true;
        }, { passive: true });
        vp.addEventListener('touchend', function (e) {
          if (!swiping) return;
          swiping = false;
          var dx = e.changedTouches[0].clientX - sx;
          var dy = e.changedTouches[0].clientY - sy;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
        }, { passive: true });
      }

      render();

      return {
        setGroup: function (name) {
          if (groups.indexOf(name) === -1) return;
          currentGroup = name;
          index = 0;
          render();
        }
      };
    }

    var carousels = {};
    root.querySelectorAll('[data-carousel]').forEach(function (el) {
      var api = initCarousel(el);
      if (api) carousels[el.dataset.carouselId || ''] = api;
    });

    /* ---- LINE UP カラータブ ---- */
    root.querySelectorAll('.color-tab').forEach(function (tabs) {
      var owner = tabs.closest('[data-carousel]');
      var api = owner ? carousels[owner.dataset.carouselId] : null;
      tabs.querySelectorAll('.color-tab__btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          tabs.querySelectorAll('.color-tab__btn').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          if (api) api.setGroup(btn.dataset.group);
        });
      });
    });

    /* ----------------------------------------------------------
       SPEC タブ
       ---------------------------------------------------------- */
    root.querySelectorAll('.spec__tabs').forEach(function (tabs) {
      var body = tabs.closest('.spec__body');
      if (!body) return;
      tabs.querySelectorAll('[data-spec-tab]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.dataset.specTab;
          tabs.querySelectorAll('[data-spec-tab]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          body.querySelectorAll('[data-spec-panel]').forEach(function (p) {
            p.classList.toggle('is-active', p.dataset.specPanel === key);
          });
        });
      });
    });

    /* ----------------------------------------------------------
       イントロ動画（クリック再生）
       ---------------------------------------------------------- */
    root.querySelectorAll('[data-video-frame]').forEach(function (frame) {
      var video = frame.querySelector('video');
      if (!video) return;
      frame.addEventListener('click', function () {
        if (frame.classList.contains('is-playing')) return;
        frame.classList.add('is-playing');
        video.play().catch(function () { /* 自動再生ブロック時は何もしない */ });
      });
    });

    /* ----------------------------------------------------------
       ビューポート内の背景動画だけ再生（負荷対策）
       ---------------------------------------------------------- */
    if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            if (v.paused) v.play().catch(function () {});
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { threshold: 0.15 });
      root.querySelectorAll('video[autoplay]').forEach(function (v) { vio.observe(v); });
    }
  }

  function boot(scope) {
    (scope || document).querySelectorAll('.cds').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  // テーマエディタでセクションを再読み込みしたとき
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
